import React from 'react';
import { ExternalSystems, FormLayout } from '../../containers';
import './ExternalSystemsPage.less';
import { ConsentDecorator } from '../../components/RoutesDecorator/ConsentDecorator';
import { TimeSyncDecorator } from '../../components/RoutesDecorator/TimeSyncDecorator';

/**
 * Страница с доступными сервисами.
 */
const ExternalSystemsPage: React.FC = () => {
    return (
        <ConsentDecorator>
            <TimeSyncDecorator>
                <FormLayout>
                    <div className="qpd-rstr-external-systems-page">
                        <ExternalSystems />
                    </div>
                </FormLayout>
            </TimeSyncDecorator>
        </ConsentDecorator>
    );
};

/**
 * Название компонента, испольуемое при отладке.
 */
ExternalSystemsPage.displayName = 'ExternalSystemsPage';

export default ExternalSystemsPage;
